export default __webpack_public_path__ + "static/media/reclame_aqui.2291e375.png";